import React, { useState, useEffect } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import CustomTable from '../../components/table/Table';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTemplates, updateTemplate } from '../../redux/Slice/showcase/templateSlice';
import { toast } from 'sonner';
import ConfirmDialog from '../../components/dialog/dialog'; 
import { clearMessage } from "../../redux/Slice/message"
import { setLoading } from "../../redux/Slice/loaderSlice"
import { useNavigate } from "react-router-dom";
import TemplateCard from '../../components/card/TemplateCard';
import Grid from "@mui/material/Grid2"




const columns = [
  { id: "sno", label: "S.No", minWidth: 100, align: "start" },

  { id: 'image', label: 'Template Image', minWidth: 150, align: 'start', renderCell: (row) => <img src={row.output} alt={row.output} width="50" height="50" /> },
  { id: 'name', label: 'Template Name', minWidth: 150, align: 'start' },
  { id: 'status', label: 'Status', minWidth: 100, align: 'center' },
  { id: 'action', label: 'Action', minWidth: 150, align: 'center', actionType: [{ view: true }] },
];

export const Inactivetemplate = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { templates, error } = useSelector((state) => state.template);
  const [searchQuery, setSearchQuery] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const message = useSelector((state) => state.message);

  useEffect(() => {
    if (message?.message) {
      toast(message.message);
      dispatch(clearMessage());
    }
  }, [message, dispatch]);

  useEffect(() => {
    const params = {
      page: page,
      limit: rowsPerPage,
      searchQuery

    };
    dispatch(fetchTemplates(params));
  }, [dispatch, page, rowsPerPage,searchQuery]);

  const handleStatusToggle = (template) => {
    setSelectedTemplate(template);
    setOpenDialog(true);
  };

  const handleConfirmStatus = async () => {
    dispatch(setLoading(true));

    if (selectedTemplate) {
      const updatedStatus = !selectedTemplate.status;
      await dispatch(updateTemplate({ id: selectedTemplate._id, formData: { ...selectedTemplate, status: updatedStatus } }))
        .then(() => {
          dispatch(fetchTemplates());
          dispatch(setLoading(false));
        })
        .catch((error) => {
          dispatch(setLoading(false));
        })
        .finally(() => {
          dispatch(setLoading(false));
          setOpenDialog(false);
        });
    }
  };

  const handleView = (template) => {
    navigate(`/show/template/${template._id}`);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setSelectedTemplate(null);
  };

  // Filter inactive templates
  const inactiveTemplates = templates?.filter((template) => !template.status);

  return (
    <div className="content">
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h5" sx={{ mb: 3, mt: 3 }}>
          Template Inactive List <Typography component="span">({inactiveTemplates.length})</Typography>
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <TextField
            placeholder="Search by Template Name"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            fullWidth
          />
          <Button variant="contained" color="success">Search</Button>
        </Box>
      </Box>

      <Grid container spacing={2}>
        {inactiveTemplates.map((template) => (
          <Grid item size={3} key={template.id}>
            <TemplateCard
              template={template}
              onView={handleView}
              onStatusToggle={handleStatusToggle}
            />
          </Grid>
        ))}
      </Grid>

      <ConfirmDialog
        open={openDialog}
        message={`Are you sure you want to mark this template as active?`}
        onClose={handleDialogClose}
        onConfirm={handleConfirmStatus}
      />
    </div>
  );
};

